import React from 'react';
import {toTitleCase} from "services/string";
import {Role} from "../../types/Role";
import {useQuery} from "react-query";
import ngage from 'services/ngage';

type Props = {
    id: string
    name: string
    label: string
    value?: number | string | null
    onChange: (role: Role | null) => any
}

function findRole(roles: Array<Role>, id: number | string): Role | null {
    return roles.find(role => role.id.toString() === id.toString()) ?? null
}

function RoleSelect({id, name, label, value, onChange}: Props) {
    const {data: roles, isLoading} = useQuery(
        ['roles.all'],
        () => ngage.roles.all()
    )

    return (
        <div>
            <label htmlFor={id} className="block text-sm font-medium text-gray-700">
                {label}
            </label>
            <select
                id={id}
                name={name}
                className="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-brand focus:outline-none focus:ring-brand sm:text-sm"
                value={value ?? undefined}
                onChange={event => onChange(findRole(roles ?? [], event.currentTarget.value))}
            >
                <option value="">Any Role</option>

                {!isLoading && roles?.map(role => (
                    <option value={role.id} key={role.id}>
                        {toTitleCase(role.name)}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default RoleSelect;